import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { GenSingleImagePreviewData } from '../../../../../../../models/google-template/preview-interfaces/gen-single-image-preview-data.interface';
import { MobileFrameComponent } from '../../../preview-common/mobile-frame/mobile-frame.component';

@Component({
    selector: 'app-gen-display-ad-mobile-17',
    imports: [CommonModule, MobileFrameComponent],
    templateUrl: './display-ad-mobile-17.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: [
        '../../../preview-common/display/display-mobile-styles.scss',
        './display-ad-mobile-17.component.scss',
    ]
})
export class DisplayAdMobile17PreviewComponent {
  @Input() data!: GenSingleImagePreviewData;

  /**
   * Row counts for the grey article text the ad is embedded in — the mock shows
   * a short paragraph above the ad and a longer run below it that fills the rest
   * of the screen. Only the counts matter, so the arrays are empty on purpose.
   */
  readonly topBars = Array.from({ length: 4 });
  readonly bottomBars = Array.from({ length: 16 });
}
